import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { isModuleEnabled, isPreviewEnabled, getCurrentCompany } from '@heyjob-dash/shared/config/company-modules';

import { paths } from 'src/routes/paths';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

// Gate rotte in base ai flag modulo dell'azienda corrente.
// Complementa il gate UI (menu/card); qui blocca l'accesso via URL diretto.
// `flag`: modulo (spento solo se false); `preview`: funzione in anteprima (accesa solo se true).
export default function ModuleGuard({ flag, preview, children }) {
  const { loading, user } = useAuthContext();

  if (loading) {
    return null;
  }

  const company = getCurrentCompany(user);
  if ((flag && !isModuleEnabled(company, flag)) || (preview && !isPreviewEnabled(company, preview))) {
    return <Navigate to={paths.dashboard.root} replace />;
  }

  return <>{children}</>;
}

ModuleGuard.propTypes = {
  flag: PropTypes.string,
  preview: PropTypes.string,
  children: PropTypes.node,
};
